<template>
  <v-container :class="item.show ? '' : 'py-0'" fluid tag="section">
    <base-material-dialog
      :title='item.data === undefined ? "评级选择" : "评级选择" '
      :dialog="item.show"
      @on-dialog-change='dialogChange'
      persistent
      :close='false'
      max-width='430'
    >
      <template v-slot:content>
        <v-card class="px-5 py-5">
          <v-form ref="form" lazy-validation>
            <v-row>
              <v-col cols="12">
                <v-radio-group v-model="form.levelId" :rules="required" row>
                  <v-radio v-for="(item, idx) in levelItems" :key="idx" :label="item.name" :value="item.id"></v-radio>
                </v-radio-group>
                <v-alert class="my-2 mb-0" border="right" colored-border type="error" elevation="1">
                  <span class="text-no-wrap primary white--text">非咨询部员工</span>请选择
                  <span class="text-no-wrap primary white--text">ST</span>
                </v-alert>
              </v-col>
            </v-row>
          </v-form>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" class="mt-3" :loading="loading" @click='save'>
              保存
            </v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </base-material-dialog>
  </v-container>
</template>

<script>
  import { level } from '@/api/system/user.js'
  import { getByPid } from '@/api/system/dictionary.js'
  import { mapActions } from 'vuex'

  export default {
    name: 'CheckLevel',
    props: {
      item: {
        type: Object,
        default: () => ({
          show: false,
          data: null
        })
      }
    },
    components: {
    },
    data() {
      return {
        loading: false,
        required: [
          value => !!value || '此项为必填项!'
        ],
        levelItems: [],
        form: {
          id: this.$store.state.userInfo.id,
          levelId: '',
        }
      }
    },
    methods: {
      ...mapActions([
        'getUserInfo'
      ]),
      save () {
        if (this.$refs.form.validate()) {
          this.loading = true
          level(this.form).then(res => {
            if (res.status === 200) {
              this.item.show = false
              this.$dialog.notify.success('操作成功', { position: 'top-right', timeout: 4000 })
              this.getUser()
            }
            this.loading = false
          })
        }
      },
      getUser () {
        this.getUserInfo().then(res => {
          if (res.status === 200) {
            this.$emit("on-load-data")
            this.$router.push({ path: '/' })
          }
        })
      },
      dialogChange (val) {
        this.item.show = val
        if (!val) {
          this.$refs.form.resetValidation()
        }
      },
      getTypes () {
        this.levelItems = []
        getByPid(this.$constants.userLevelPid).then(res => {
          if (res.status === 200) {
            res.data.forEach(item => {
              if (item.code !== '0') {
                this.levelItems.push(item)
              }
            })
          }
        })
      }
    },
    created () {
      this.getTypes()
    }
  }
</script>

<style>
</style>
